import React from "react";
import SettingsIcon from "@mui/icons-material/Settings";
import FancyLink from "~/components/parts/FancyLink";

const ManageCoursesLink = ({ className, href = "/manage-courses.php" }) => {
  return (
    <FancyLink
      {...{ className, href }}
      onClick={() => {
        sessionStorage.setItem("manageCoursesView", "school");
      }}
    >
      <div className="flex flex-none justify-center transition-transform duration-500 group-hover:rotate-180">
        <SettingsIcon sx={{ fontSize: "18px" }} />
      </div>
      <span>Manage school courses</span>
    </FancyLink>
  );
};

export default ManageCoursesLink;
